import { s as a, f as n, m as o, n as c } from "./index-BKMcmhwk.js";
let t = null;
const r = (e) => {
  t = e;
}, u = () => t, k = (e) => {
  var s;
  a(e.env), r(e.source), n((s = e.accessMode) != null ? s : "secure"), e.getAuthTokenCallback && o(e.getAuthTokenCallback), e.axiosInstance && c(e.axiosInstance);
};
export {
  u as g,
  k as i
};
